import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { ModaleResultatComponent } from '../modale-resultat/modale-resultat.component';

@Component({
  selector: 'app-creer-mot-de-passe',
  templateUrl: './creer-mot-de-passe.component.html',
  styleUrls: ['./creer-mot-de-passe.component.scss'],
  standalone: false
})

export class CreerMotDePasseComponent {
  id: string;
  code: string;
  motDePasse: string;
  motDePasseConf: string;
  mdpDifferents = false;
  mdpValide = false;
  mailConfirmed = false;
  demandeValide = true;
  erreurValidation = false;
  mdpRequis = false;
  mdpLongMini = false;
  tokenInvalide = false;
  usernameInvalide = false;
  emailDejaConfirme = false;
  modalRef: BsModalRef;
  username: string;

  constructor(private readonly route: ActivatedRoute, private readonly http: HttpService, private readonly router: Router, private readonly modalService: BsModalService, private readonly traductionService: TraductionService,
    private readonly fonctionsService: FonctionsService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.id = params.params['id'];
      this.code = params.params['code'];
    });
    let requetes = [this.http.get<string>('Users/' + this.id + '/language'),
    this.http.get<string>('Users/' + this.id + '/username')];
    forkJoin(requetes).subscribe(resultat => {
      this.traductionService.changerLangue(resultat[0]);
      this.username = resultat[1];
    });
  }

  onSubmit() {
    if (this.isValidPassword()) {
      this.fonctionsService.loading_screen(true);
      this.http.post('Authentication/ConfirmEmail', { Id: this.id, MotDePasse: this.motDePasse, Code: this.code }).subscribe(result => {
        this.fonctionsService.loading_screen(false);
        if (!result['succeeded']) {
          if (result['errors'][0]['code'] === 'InvalidToken')
            this.tokenInvalide = true;
          else if (result['errors'][0]['code'] === 'InvalidUserName')
            this.usernameInvalide = true;
          else if (result['errors'][0]['code'] === 'EmailAlreadyConfirm')
            this.emailDejaConfirme = true;
          this.demandeValide = false;
        } else {
          this.creerMotDePasse();
        }
      }, error => {
        this.demandeValide = false;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  creerMotDePasse() {
    this.fonctionsService.loading_screen(true);
    this.http.post('Authentication/CreatePassword', { Id: this.id, MotDePasse: this.motDePasse }).subscribe(result => {
      this.fonctionsService.loading_screen(false);
      if (result['succeeded']) {
        this.traductionService.translate.get(['CREER_MOT_DE_PASSE.MODALE_TITRE_REUSSIE', 'CREER_MOT_DE_PASSE.MODALE_MESSAGE_REUSSIE']).subscribe(traduction => {
          const initialState = {
            titre: traduction['CREER_MOT_DE_PASSE.MODALE_TITRE_REUSSIE'],
            resultat: traduction['CREER_MOT_DE_PASSE.MODALE_MESSAGE_REUSSIE']
          };
          this.modalRef = this.modalService.show(ModaleResultatComponent, { initialState });
          this.modalRef.content.event.subscribe(() => {
            this.router.navigate(['login']);
          });
        });
      } else {
        this.erreurValidation = true;
      }
    }, () => {
      this.erreurValidation = true;
      this.fonctionsService.loading_screen(false);
    });
  }

  isValidPassword() {
    this.mdpRequis = (this.motDePasse === undefined || this.motDePasseConf === undefined || this.motDePasse == '');
    this.mdpDifferents = (this.motDePasseConf == '' || this.motDePasse != this.motDePasseConf);
    this.mdpLongMini = this.motDePasse.length < 10;
    return (!this.mdpRequis && !this.mdpDifferents && !this.mdpLongMini);
  }
}
